import { padLeft } from '@/utils/pafLeft';
import { copy } from '@/utils/copy';
import { getFatorVencimento } from '@/utils/getFatorVencimento';
import { IGerarBoletoBancoBrasil } from './types';

export function gerarDadosBoleto({ dados }: IGerarBoletoBancoBrasil) {
  try {
    const {
      bancario,
      parcela,
    } = dados;

    parcela.valor = Number(parcela.valor);
    const fatorVencimento = getFatorVencimento(parcela.vencimento);
    const valor = getValor(parcela.valor);
    const convenio = bancario.convenio;

    let nossoNumero = '';
    let numeroDocumento = '';
    let campoLivre = '';
    if (convenio.length === 6) {
      switch (parcela.tipoDocumento) {
        case 'NFE':
          numeroDocumento = padLeft(`${parcela.id_boleto}2`, 5);
          break;
        case 'FAT':
          numeroDocumento = padLeft(`${parcela.id_boleto}4`, 5);
          break;
        case 'FIN':
          numeroDocumento = padLeft(`${parcela.id_boleto}5`, 5);
        break;
      }
      nossoNumero = getNossoNumero(`${convenio}${numeroDocumento}`);
      campoLivre =
        copy(nossoNumero, 1, 11) +
        padLeft(bancario.agencia, 4) +
        padLeft(`${bancario.numero}${bancario.numero_dv}`, 8) +
        padLeft(bancario.carteira, 2);
    } else if (convenio.length === 7) {
      switch (parcela.tipoDocumento) {
        case 'NFE':
          numeroDocumento = padLeft(`${parcela.id_boleto}2`, 10);
          break;
        case 'FAT':
          numeroDocumento = padLeft(`${parcela.id_boleto}4`, 10);
          break;
        case 'FIN':
          numeroDocumento = padLeft(`${parcela.id_boleto}5`, 10);
        break;
      }
      nossoNumero = `${convenio}${numeroDocumento}`;
      campoLivre = `000000${nossoNumero}${padLeft(bancario.carteira, 2)}`;
    }

    const digitoGeral = getDigitoGeral(`0019${fatorVencimento}${valor}${campoLivre}`);
    const codigoBarra = `0019${digitoGeral}${fatorVencimento}${valor}${campoLivre}`;

    const campo1 = copy(codigoBarra, 1, 3) + copy(codigoBarra, 4, 4) + copy(codigoBarra, 20, 24);
    const campo2 = copy(codigoBarra, 25, 34);
    const campo3 = copy(codigoBarra, 35, 44);
    const campo4 = copy(codigoBarra, 5, 5);
    const campo5 = copy(codigoBarra, 6, 9) + copy(codigoBarra, 10, 19);

    const digito1 = getDigito(campo1);
    const digito2 = getDigito(campo2);
    const digito3 = getDigito(campo3);
    /* const digito4 = getDigito(campo4); Aviso: No solution está errado, mas da certo, esse digito 4 não usa*/

    const linhaDigitavel = campo1 + digito1 + campo2 + digito2 + campo3 + digito3 + campo4 /*+ digito4*/ + campo5;

    const dadosBoleto = {
      linhaDigitavel,
      fatorVencimento,
      valor,
      convenio,
      nossoNumero,
      campoLivre,
      digitoGeral,
      codigoBarra,
      numeroDocumento
    };

    return dadosBoleto;
  } catch (error) {
    console.log('Falha ao gerar dados do boleto', error);
    return null;
  }
}

function getValor(valor: number) {
  const valorFormatado = valor.toFixed(2).replace(/\D/g, '');
  return padLeft(valorFormatado, 10);
}

export function getNossoNumero(auxiliar: string) {
  let i = 11, j = 10, soma = 0;

  while (i >= 1) {
    j--;
    if (j === 1) j = 9;
    const numero = Number(copy(auxiliar, i, i));
    soma += j * numero;
    i--;
  }

  const resto = soma % 11;
  const digito = resto < 10 ? String(resto) : 'X';
  const nosso_numero = auxiliar + digito;

  return nosso_numero;
}

function getDigitoGeral(texto: string) {
  let i = 43;
  let j = 1;
  let soma = 0;

  while (i >= 1) {
    j++;
    if (j === 10) j = 2;
    const valor = Number(copy(texto, i, i));
    soma += j * valor;
    i--;
  }

  const resto = soma % 11;
  let digito = 11 - resto;
  if (digito === 0 || digito > 9) digito = 1;

  return String(digito);
}

function getDigito(texto: string) {
  let i = texto.length;
  let j = 1;
  let total = 0;
  let soma = 0;
  let digito = 0;

  while (i >= 1) {
    j = j === 1 ? 2 : 1;

    let valor = Number(copy(texto, i, i));
    total = valor * j;

    if (total >= 10) {
      valor = Number(copy(total, 1, 1)) + Number(copy(total, 2, 2));
    } else {
      valor = total;
    }

    soma += valor;
    i--;
  }

  const uni = Number(copy(soma, String(soma).length, String(soma).length));
  digito = 10 - uni;
  if (digito === 10) digito = 0;
  return String(digito);
}
